import React from "react";

import { COLORS } from "rylak-common/src/constants";
import { RISK_LEVEL } from "~/constants";
import { CHIP_COLOR_TYPES, ChipTooltip } from "~/components/chips/CustomChip.jsx";
import { EntityActionStatusChipDeprecated } from "~/components/entityAction/EntityActionStatusChip.jsx";

function ComplaintStatusTooltip({ title, content, riskScore } = {}) {
    return (
        <ChipTooltip
            title={
                <div>
                    <span style={{ color: COLORS.WEAK_TEXT }}>Risk Level - </span>
                    {title} {riskScore && `(${riskScore})`}
                </div>
            }
            content={content}
        />
    );
}

function LabelComponent({ riskScore, label }) {
    return (
        <span>
            {label} {riskScore && <span style={{ fontSize: "10px" }}>({riskScore})</span>}
        </span>
    );
}

const labelHigh = "High";
const labelNormal = "Normal";
const labelLow = "Low";

export const RISK_LEVEL_MAP = {
    [RISK_LEVEL.HIGH]: {
        colorType: CHIP_COLOR_TYPES.WARNING,
        label: labelHigh,
        labelFn: (props) => <LabelComponent {...props} label={labelHigh} />,
        tooltipTitleFn: ({ riskScore }) => (
            <ComplaintStatusTooltip
                title={labelHigh}
                riskScore={riskScore}
                content={"A risk score of greater than 70 is deemed to be high. The risk score is determined from a variety of parameters based on the customers return history."}
            />
        ),
    },
    [RISK_LEVEL.NORMAL]: {
        colorType: CHIP_COLOR_TYPES.DONE,
        label: labelNormal,
        labelFn: (props) => <LabelComponent {...props} label={labelNormal} />,
        tooltipTitleFn: ({ riskScore }) => (
            <ComplaintStatusTooltip
                title={labelNormal}
                riskScore={riskScore}
                content={"The risk score is deemed to be normal. The risk score is determined from a variety of parameters based on the customers return history."}
            />
        ),
    },
    [RISK_LEVEL.LOW]: {
        colorType: CHIP_COLOR_TYPES.OK,
        label: labelLow,
        labelFn: (props) => <LabelComponent {...props} label={labelLow} />,
        tooltipTitleFn: ({ riskScore }) => (
            <ComplaintStatusTooltip
                title={labelLow}
                riskScore={riskScore}
                content={"A risk score of less than 30 is deemed to be low risk. The risk score is determined from a variety of parameters based on the customers return history."}
            />
        ),
    },
};

export default function RiskLevelChip(props) {
    const customer = props?.customer;
    const riskScore = props?.riskScore || customer?.riskScore;
    const status = props?.status || customer?.riskLevel;
    return <EntityActionStatusChipDeprecated statusData={RISK_LEVEL_MAP[status]} {...props} riskScore={riskScore} status={status} />;
}
